import { Component, OnInit, Output, EventEmitter, Inject, inject, OnDestroy } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ModalImagenAyudaPolizaComponent } from 'src/app/pages/clientes/@components/modal-imagen-ayuda-poliza/modal-imagen-ayuda-poliza.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AdministrarUsuariosService } from 'src/app/services/administracion-usuarios/administrar-usuarios.service';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { IResponseValidaContrasena, Validacion } from 'src/app/models/administracion-usuarios/administracion-usuarios.model';
import ValidationRegistro from '../validators/registro.validators';
import { INormaModelInput, IResponseModel } from 'src/app/models/seguros-atlas/atlas.model';
import { ComponentType } from '@angular/cdk/portal';
import { ValidadorDosFaComponent } from '../validador-dos-fa/validador-dos-fa.component';
import { BlockUI, NgBlockUI, BlockUIModule } from 'ng-block-ui';
import { BlockTemplateComponent } from 'src/app/@theme/@components';
import { AppState } from 'src/app/@store/app.reducers';
import { Store } from '@ngrx/store';
import { ActivarLoadingAction, DesactivarLoadingAction } from 'src/app/@store/actions';
import { MatFormField, MatLabel, MatSuffix, MatError, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton, MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { InputFechaActualizacionComponent } from '../../../../@theme/@components/input-fecha-actualizacion/input-fecha-actualizacion.component';
import { MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { UpperCaseTextDirective } from '../../../../@shared/directives/upper-case.directive';
import { OnlyNumber } from '../../../../@shared/directives/only-number.directive';
import { MatSelect, MatOption } from '@angular/material/select';

@Component({
    selector: 'app-snackbar-errores-password',
    template: `
    <div class="text-small" [innerHTML]="data.html"></div>
  `,
    styles: ['.text-small {font-size : 12px !important}'],
    standalone: false
})
export class SnackbarMsmComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBar: MatSnackBar) {
  }
}

export interface Pregunta {
  value: string;
  viewValue: string;
}

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-registro-asegurado-component',
    templateUrl: './registro-asegurado.component.html',
    styleUrls: ['./registro-asegurado.component.scss'],
    imports: [BlockUIModule, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIconButton, MatSuffix, MatIcon, MatError, MatButton, NgClass, MatPrefix, InputFechaActualizacionComponent, MatDatepickerToggle, MatDatepicker, UpperCaseTextDirective, OnlyNumber, MatSelect, MatOption]
})

export class RegistroAseguradoComponent implements OnInit, OnDestroy {

    //Block UI
  @BlockUI() blockUI: NgBlockUI | any;
  subsReduxUI = new Subscription();
  public template: string = 'corporativo';
  blockTemplate = BlockTemplateComponent;
  public store = inject(Store<AppState>);

  activarBtn = false;
  imagen: string;
  loading = false;
  hide = true;
  formularioAse: FormGroup;
  subsFormPassword$: Subscription;
  generaErrorPasswordForm = false;
  validandoPassword = false;
  // variable para catalogo de preguntas secretas
  catPreguntas: [] = [];
  emailAnterior: string;
  telefonoAnterior: string;
  validandoTelefono = false;
  validandoCorreo = false;
  validaTelefono = false;
  validaEmail = false;

  @Output() evento = new EventEmitter();
  errores: any = '';
  subsFormLinea = new Subscription();
  reglas = [
    { Linea: 1, Inciso: true, Ubicacion: false, Certificado: false, Seccion: false },
    { Linea: 2, Inciso: false, Ubicacion: true, Certificado: false, Seccion: false },
    { Linea: 4, Inciso: false, Ubicacion: false, Certificado: true, Seccion: false },
    { Linea: 3, Inciso: false, Ubicacion: false, Certificado: true, Seccion: true },
    { Linea: 7, Inciso: false, Ubicacion: false, Certificado: true, Seccion: true },
    { Linea: 8, Inciso: false, Ubicacion: false, Certificado: true, Seccion: true }
  ]
  imagenTooltip: string = 'assets/img/ejemplos-poliza/ColectivoAccidentesPersonales.jpg';
  linea = '';
  producto = '';
  
  colorBotones: string = "#ef3c46";

  constructor(private authService: AuthService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private adminService: AdministrarUsuariosService) { }

  ngOnDestroy(): void {
    this.subsReduxUI.unsubscribe();
  }

  ngOnInit() {
    // Suscripción a store redux UI
    this.subsReduxUI = this.store.select('ui').subscribe(data => {
      const loading = data?.block?.isLoading;
      const message = data?.block?.message || 'Cargando...';

      if (loading) {
        if (!this.blockUI.isActive) {
          this.blockUI.start(message);
        }
      } else {
        this.blockUI.stop();
      }
    });
    
    this.imagenAleatoria();
    this.instaciarFiltros();
    this.catalogoPreguntas();
    this.subsFormLinea = this.formularioAse.get('Linea').valueChanges.pipe(debounceTime(500)).subscribe(ln => {
      if (ln === '1' || ln === '2' || ln === '4' || ln === '3' || ln === '7' || ln === '8') {
        const linea = this.reglas.find(item => item.Linea === parseInt(ln, 10));
        this.formularioAse.get('Inciso')[linea.Inciso ? 'enable' : 'disable']();
        this.formularioAse.get('Ubicacion')[linea.Ubicacion ? 'enable' : 'disable']();
        this.formularioAse.get('Certificado')[linea.Certificado ? 'enable' : 'disable']();
        this.formularioAse.get('Seccion')[linea.Seccion ? 'enable' : 'disable']();
        linea.Inciso ? null : this.formularioAse.get('Inciso').reset(0);
        linea.Ubicacion ? null : this.formularioAse.get('Ubicacion').reset(0);
        linea.Certificado ? null : this.formularioAse.get('Certificado').reset(0);
        linea.Seccion ? null : this.formularioAse.get('Seccion').reset(0);
        this.activarBtn = true;
      } else {
        this.activarBtn = false;
      }
      this.linea = ln;
      this.tipoImagenTooltip(this.linea, this.producto);
    });
    this.formularioAse.get('Producto').valueChanges.pipe(debounceTime(500)).subscribe(pr => {
      this.producto = pr;
      this.tipoImagenTooltip(this.linea, this.producto);
    })
     this.subsFormPassword$ = this.formularioAse.get('Password').valueChanges
          .pipe(
            tap(contrasena => {
            this.validandoPassword = true;
          }),debounceTime(1000), distinctUntilChanged())
          .subscribe((pass: string) => {
            if (pass.length > 0) this.validarContrasena(pass);
            else this.reiniciarValidacionesContrasena();
          });


    this.formularioAse.get('Email').valueChanges.
      pipe(distinctUntilChanged()).subscribe((nuevoEmail: string) => {
        if (this.validandoCorreo && this.formularioAse.get('Email').value != this.emailAnterior)
          this.solicitaConfirmacionEmail(nuevoEmail);
        else
          this.emailAnterior = this.formularioAse.get('Email').value;
      });

    this.formularioAse.get('Telefono').valueChanges.
      pipe(distinctUntilChanged()).subscribe((nuevoTelefono: string) => {
        if (this.validandoTelefono && this.formularioAse.get('Telefono').value != this.telefonoAnterior)
          this.solicitaConfirmacionTelefono(nuevoTelefono);
        else
          this.telefonoAnterior = this.formularioAse.get('Telefono').value;
      });
  }

  // Carga el catalogo de preguntas secretas
  catalogoPreguntas() {
    this.store.dispatch(ActivarLoadingAction());
    this.authService.catalogoPreguntas().subscribe(resp => {
      this.store.dispatch(DesactivarLoadingAction());
      this.catPreguntas = Object.assign(resp);
    }, (err) =>{
      this.store.dispatch(DesactivarLoadingAction());
    });
  }

  registrar() {
     if (!this.validandoTelefono) {
      this.abrirSwalAlertAviso('error', 'Error al registrar', "El Número telefónico no esta validado", 'Aceptar', null);
      return;
    }
    if (!this.validandoCorreo) {
      this.abrirSwalAlertAviso('error', 'Error al registrar', "El Email no esta validado", 'Aceptar', null);
      return;
    }
    if (this.generaErrorPasswordForm) return this.abrirSnackBar('La contraseña de tener un formato correcto', `Contraseña`, 'exitoSnackbar');
    this.store.dispatch(ActivarLoadingAction());
    this.authService.registroUsuario(this.formularioAse.getRawValue()).subscribe(resp => {
      this.store.dispatch(DesactivarLoadingAction());
      this.errores = resp['claveUsuario']
      this.abrirSwalAlertAviso('success', 'Usuario registrado', '', 'Aceptar', null);
      this.regresar();
    }, err => {
      this.store.dispatch(DesactivarLoadingAction());
      this.errores = '';
      if (err?.error?.Message) this.errores = err.error.Message;
      if (err?.error && Array.isArray(err?.error)) {
        err.error.forEach(element => {
          this.errores = `${this.errores}${element.Exception}`
        });
      }
      this.abrirSwalAlertAviso('error', 'Error al registrar', this.errores, 'Aceptar', null);
    });

  }

  instaciarFiltros() {
    this.formularioAse = new FormGroup({
      Sucursal: new FormControl(null, Validators.required),
      Linea: new FormControl(null, Validators.required),
      Producto: new FormControl(null, Validators.required),
      Poliza: new FormControl(null, Validators.required),

      Seccion: new FormControl({ value: 0, disabled: true }, Validators.required),
      Inciso: new FormControl({ value: 0, disabled: true }, Validators.required),
      Ubicacion: new FormControl({ value: 0, disabled: true }, Validators.required),
      Certificado: new FormControl({ value: 0, disabled: true }, Validators.required),

      Dependiente: new FormControl(0, Validators.required),
      AnioEmision: new FormControl(0, Validators.required),
      Reexpedicion: new FormControl(0, Validators.required),

      Password: new FormControl("", [Validators.required]),
      ConfirmaPassword: new FormControl("", [Validators.required]),
      VerificarE: new FormControl(0),
      Telefono: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{12}$'), Validators.minLength(12), Validators.maxLength(12)]),
      CodTelefono: new FormControl(null),
      Alias: new FormControl('', Validators.required),
      IdPregunta: new FormControl('', Validators.required),
      Respuesta: new FormControl('', Validators.required),

      Email: new FormControl("", [Validators.required, Validators.email]),
      CodEmail: new FormControl(null),
      FechaInicioVigencia: new FormControl(null, Validators.required),
    }, {
      validators: ValidationRegistro.match('Password', 'ConfirmaPassword')
    });
  }

  regresar() {
    this.evento.emit(true);
  }

  imagenAleatoria() {
    this.imagen = `assets/img/${Math.floor((Math.random() * Math.floor(5)) + 1)}.jpg`;
    setTimeout(() => {
      this.imagenAleatoria();
    }, 30000);
  }
  openModalImagenAyuda() {
    this.dialog.open(ModalImagenAyudaPolizaComponent, {
      data: {
        urlImage: this.imagenTooltip
      }
    })
  }

  validarContrasena(password: string) {
    if(this.contrasenaVacia) return this.reiniciarValidacionesContrasena();

    let msgError = '';
    
    const request = { password, usuario: "" };
    this.adminService.postValidaContrasena(request).subscribe((resp: IResponseValidaContrasena) => {
      this.validandoPassword = false;
      if (resp?.datos.length > 0) {
        this.generaErrorPasswordForm = true;
        this.procesarErroresPassword(resp.datos);
        this.formularioAse.get('Password')?.setErrors({
          formatoIncorrecto: true
        });
        document.getElementById('iconPass').style.color = '#8395a7';
      } else {
        this.generaErrorPasswordForm = false;
        const control = this.formularioAse.get('Password');
        if (control?.hasError('formatoIncorrecto')) {
          delete control.errors!['formatoIncorrecto'];
          if (Object.keys(control.errors || {}).length === 0) {
            control.setErrors(null);
          }
        }
        document.getElementById('iconPass').style.color = '#10ac84';
      }
    }, error => {
      const err = error.error || [];
      if (!err.length) msgError = "Ups, no se pudo comprobar el formato de la contraseña";
      err.forEach((element, index) => {
        if (element.Visible) msgError = index === 0 ? element.Exception : `${msgError} ${element.Exception}`;
        if (element.password) msgError = element.password[0];
      });
      
      this.reiniciarValidacionesContrasena();
      this.abrirSnackBar(msgError, `Contraseña`, 'errorSnackbar');
    });
  }

  procesarErroresPassword(array: Validacion[]) {
    let msgError = "";
    array.forEach((element) => {
      if (array.length === 1)
        msgError += `<li> ${element.Descripcion} </li>`;
      else
        msgError += `<li> ${element.Descripcion} </li> <br>`;
    });
    this.abrirSnackBar(msgError, `Contraseña`, 'exitoSnackbar');
  }

  abrirSnackBar(mensaje: string, titulo: string, clase: string) {
    this.snackBar.openFromComponent(SnackbarMsmComponent, {
      duration: 5000,
      panelClass: clase,
      data: {
        html: mensaje
      }
    })
  }


  tipoImagenTooltip(ln, pr) {
    // Images
    if (ln == 1 && pr == 24) return this.imagenTooltip = 'assets/img/ejemplos-poliza/FlotillaAutos.jpg';
    if (ln == 3 && pr == 3) return this.imagenTooltip = 'assets/img/ejemplos-poliza/GrupoGastosMedicosMayores.jpg';
    if (ln == 8 && pr == 11) return this.imagenTooltip = 'assets/img/ejemplos-poliza/ColectivoAccidentesPersonales.jpg';
    if (ln == 1) return this.imagenTooltip = 'assets/img/ejemplos-poliza/IndividualAutos.jpg';
    if (ln == 2) return this.imagenTooltip = 'assets/img/ejemplos-poliza/IndividualDanos.jpg';
    if (ln == 3) return this.imagenTooltip = 'assets/img/ejemplos-poliza/IndividualGastosMedicosMayores.jpg';
    if (ln == 4) return this.imagenTooltip = 'assets/img/ejemplos-poliza/IndividualVidaIndividual.jpg';
    if (ln == 7) return this.imagenTooltip = 'assets/img/ejemplos-poliza/GrupoVidaGrupo.jpg';
    if (ln == 8) return this.imagenTooltip = 'assets/img/ejemplos-poliza/IndividualAccidentesPersonales.jpg';
  }

  ValidarTelefono() {
    this.store.dispatch(ActivarLoadingAction());

    this.validandoTelefono = false;
    const norma: INormaModelInput = {
      NumNorma: 765,
      Parametro1: 1,
      Parametro2: 0,
      Parametro3: 0,
    };

    this.authService.obtenerNormaAtlas(norma).subscribe(
      (res: IResponseModel) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (res.Respuesta.Status == 1) {
          let component: ComponentType<any>;
          component = ValidadorDosFaComponent;
          const configModal: MatDialogConfig<any> = {
            data: { tipo: "Telefono", valor: this.formularioAse.get('Telefono').value, usuario: "" }
          };
          const dialogRef = this.dialog.open(component, configModal).afterClosed().subscribe(result => {

            if (result.TwoFactorCode != null && result.TwoFactorCode != "") {
              this.formularioAse.get('CodTelefono').setValue(result.TwoFactorCode);
              this.validandoTelefono = true;
            } else {
              this.formularioAse.get('CodTelefono').setValue("");
              this.validandoTelefono = false;
            }

          });
        } else {
          this.formularioAse.get('CodTelefono').setValue("9000");
          this.validandoTelefono = true;
        }
      },
      (error) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.abrirSwalAlertAviso('error', 'Error al registrar', "Intenta solicitar tu código mas tarde", 'Aceptar', null);
        this.formularioAse.get('CodTelefono').setValue("");
        this.validandoTelefono = false;
      }
    );
  }

  ValidarCorreo() {
    this.store.dispatch(ActivarLoadingAction());

    this.validandoCorreo = false;
    const norma: INormaModelInput = {
      NumNorma: 763,
      Parametro1: 1,
      Parametro2: 0,
      Parametro3: 0,
    };

    this.authService.obtenerNormaAtlas(norma).subscribe(
      (res: IResponseModel) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (res.Respuesta.Status == 1) {
          let component: ComponentType<any>;
          component = ValidadorDosFaComponent;
          const configModal: MatDialogConfig<any> = {
            data: { tipo: "Correo Electronico", valor: this.formularioAse.get('Email').value, usuario: "" }
          };
          const dialogRef = this.dialog.open(component, configModal).afterClosed().subscribe(result => {

            if (result.TwoFactorCode != null && result.TwoFactorCode != "") {
              this.formularioAse.get('CodEmail').setValue(result.TwoFactorCode);
              this.validandoCorreo = true;
            } else {
              this.formularioAse.get('CodEmail').setValue("");
              this.validandoCorreo = false;
            }

          });
        } else {
          this.formularioAse.get('CodEmail').setValue("9000");
          this.validandoCorreo = true;
        }
      },
      (error) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.abrirSwalAlertAviso('error', 'Error al registrar', "Intenta solicitar tu código mas tarde", 'Aceptar', null);
        this.formularioAse.get('CodEmail').setValue("");
        this.validandoCorreo = false;
      }
    );
  }
  get mostrarErrorUsuario(): boolean {
    const sucursalCtrl = this.formularioAse.get('Sucursal');
    const lineaCtrl = this.formularioAse.get('Linea');
    const productoCtrl = this.formularioAse.get('Producto');
    const polizaCtrl = this.formularioAse.get('Poliza');

    const validado = this.formularioAse.get('Sucursal').invalid || this.formularioAse.get('Linea').invalid || this.formularioAse.get('Producto').invalid || this.formularioAse.get('Poliza').invalid;
    const tocado = sucursalCtrl?.touched || lineaCtrl?.touched || productoCtrl?.touched || polizaCtrl?.touched;
    //const valor = sucursalCtrl?.value || lineaCtrl?.value || productoCtrl?.value || polizaCtrl?.value;
    return validado && tocado;
  }

  solicitaConfirmacionEmail(nuevoEmail: string) {
    Swal.fire({
      title: 'Si cambias el email tendras que validarlo nuevamente',
      text: "¿Deseas cambiar el email?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cambiar',
      cancelButtonText: 'No, mantener anterior',
      cancelButtonColor: this.colorBotones,
      confirmButtonColor: this.colorBotones,
    }).then((result) => {
      if (result.isConfirmed) {
        this.emailAnterior = nuevoEmail;
        this.validandoCorreo = false;
      }
      this.formularioAse.get('Email').setValue(this.emailAnterior);
    });
  }

  solicitaConfirmacionTelefono(nuevoTelefono: string) {
    Swal.fire({
      title: 'Si cambias el telefono tendras que validarlo nuevamente',
      text: "¿Deseas cambiar el telefono?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cambiar',
      cancelButtonText: 'No, mantener anterior',
      cancelButtonColor: this.colorBotones,
      confirmButtonColor: this.colorBotones,
    }).then((result) => {
      if (result.isConfirmed) {
        this.telefonoAnterior = nuevoTelefono;
        this.validandoTelefono = false;
      }
      this.formularioAse.get('Telefono').setValue(this.telefonoAnterior);
    });
  }

  reiniciarValidacionesContrasena(){
    const control = this.formularioAse.get('Password');
    
      this.generaErrorPasswordForm = false;
      document.getElementById('iconPass').style.color = '#8395a7';
      this.validandoPassword = false;
      if (control?.hasError('formatoIncorrecto')) {
          delete control.errors!['formatoIncorrecto'];
          if (Object.keys(control.errors || {}).length === 0) {
            control.setErrors(null);
          }
        }
  }

    abrirSwalAlertAviso(icono: string, titulo: string, texto: string, textoCon: string, textoCan: string){
      Swal.fire({
          icon: (icono === "success" ? 'success' : icono === "warning" ? 'warning' : 'error'),
          title: titulo,
          html: texto,
          confirmButtonText: textoCon,
          cancelButtonText: textoCan,
          showCancelButton: (textoCan ? true : false),
          cancelButtonColor: this.colorBotones,
          confirmButtonColor: this.colorBotones,
        });
    }

  get contrasenaVacia():boolean {
    if(this.formularioAse.get("Password").value === null) return true;
    else if(this.formularioAse.get("Password").value.trim() === "") return true;
    else return false;
    }
}